import moment from 'moment';

export const setDefaultDateFormat = (date) => {
  if (!date) {
    return 'N/A';
  }

  return moment(date).format('YYYY-MM-DD HH:mm');
};
